import React, {Component} from 'react';
import MyProfileContainer from "./container/MyProfileContainer";

class MyProfile extends Component {
    componentDidMount() {
        window.scrollTo(0,0)
    }
    render() {
        return (
            <MyProfileContainer {...this.props} />
        );
    }
}

export default MyProfile;
